<template>
  <div class="things-like-container">
    <el-row :gutter="20" type="flex">
      <el-col :span="12">
        <common-card card-title="想去的国家">
          <div class="tag-container" :style="{ minHeight }">
              <el-tag
                :key="tag.id"
                v-for="tag in userDetailCountries"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{ tag.countryName }}
              </el-tag>
            <el-select
              class="input-new-tag"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              v-if="inputVisible"
              v-model="inputValue"
              filterable
              remote
              reserve-keyword
              placeholder="请输入国家"
              :remote-method="remoteMethod"
              :loading="cityLoading">
              <el-option
                v-for="item in options"
                :key="item.areaCode"
                :label="item.label"
                :value="item">
              </el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">添加国家</el-button>
          </div>
        </common-card>
      </el-col>
      <el-col :span="12">
        <common-card card-title="想去的城市">
          <div class="tag-container" :style="{ minHeight }">
            <el-tag
              :key="tag.id"
              v-for="tag in userDetailCities"
              closable
              :disable-transitions="false"
              @close="handleCloseCity(tag)">
              {{ tag.cityName }}
            </el-tag>
            <el-select
              class="input-new-tag"
              ref="saveTagInputCity"
              size="small"
              @keyup.enter.native="handleInputConfirmCity"
              v-if="inputVisibleCity"
              v-model="inputValueCity"
              filterable
              remote
              reserve-keyword
              placeholder="请输入城市"
              :remote-method="remoteMethodCity"
              :loading="cityLoadingCity">
              <el-option
                v-for="item in optionsCity"
                :key="item.areaCode"
                :label="item.label"
                :value="item">
              </el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInputCity">添加城市</el-button>
          </div>
        </common-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CommonCard from "@/components/CommonCard";
import { mapGetters } from "vuex";
import { payTypeEnum } from "../const";
import {getCityOptions,getWorldCountryOptions} from "@/api/dynamic";
import { initCountries, initCities ,saveCountries,saveCities,deleteCountries,deleteCities} from '@/api/user'

export default {
  name: "DetailThingsLike",
  components: {
    CommonCard
  },
  data() {
    return {
      payTypeEnum,
      userId:'',
      cityLoading:false,
      cityLoadingCity:false,
      minHeight: "100px",
      userDetailCountries: [],
      inputVisible: false,
      inputValue: '',
      inputVisibleCity: false,
      inputValueCity: '',
      optionsCity: [],
      options: [],
      userDetailCities:[]
    };
  },
  computed: {
  },
  created() {
    this.userId = this.$route.query.userId
    this.initCountries()
    this.initCities()
  },
  methods:{

    initCountries(){
      initCountries(this.userId).then(res =>{
        this.userDetailCountries = res.data
      })

    },
    initCities(){
      initCities(this.userId).then(res =>{
        this.userDetailCities = res.data
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.cityLoading = true;
        getWorldCountryOptions({"country":query}).then(res =>{
          this.cityLoading = false;
          this.options = res.data
        })
      } else {
        this.options = [];
      }
    },

    handleClose(tag) {
      deleteCountries(tag.id).then((res)=>{
        this.initCountries()
      })
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        console.log(inputValue)
        let param ={}
        param.userId = this.userId
        param.countryName= inputValue.label
        param.countryCode= inputValue.value
        saveCountries(param).then(()=>{
          this.initCountries()
        })
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    //城市
    remoteMethodCity(query) {
      if (query !== '') {
        this.cityLoadingCity = true;
        getCityOptions({"city":query}).then(res =>{
          this.cityLoadingCity = false;
          this.optionsCity = res.data
        })
      } else {
        this.optionsCity = [];
      }
    },

    handleCloseCity(tag) {
      deleteCountries(tag.id).then((res)=>{
        this.initCities()
      })
    },

    showInputCity() {
      this.inputVisibleCity = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInputCity.focus();
      });
    },

    handleInputConfirmCity() {
      let inputValue = this.inputValueCity;
      if (inputValue) {
        console.log(inputValue)
        let param ={}
        param.userId = this.userId
        param.cityName= inputValue.label
        param.cityCode= inputValue.value
        saveCities(param).then(()=>{
          this.initCities()
        })
      }
      this.inputVisibleCity = false;
      this.inputValueCity = '';
    }

  }
}
</script>

<style lang="scss" scoped>
.things-like-container {
  margin-top: 1.2rem;
  .tag-container {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .tag {
      margin-top: 16px;
      margin-left: 18px;
      height: 20px;
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 150px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
